import { loadLargeImage } from '../articleImage';
import { correctArticleHeight } from '../../articleHelper';
import ArticlePresenter from '../../articlePresenter';
import Breadcrumb from '../breadcrumb';
import ListTeaser from '../../components/listTeaser';
import React from 'react';
import $ from 'jquery';

class TeaserArticles extends React.Component {
  constructor() {
    super();
    this.state = {
      article: [],
      teaserArticles: []
    };
  }

  componentDidMount() {
    this.ajaxArticle();
    this.ajaxTeaserArticles();
  }

  componentDidUpdate() {
    const { articleId } = this.props;

    correctArticleHeight(articleId);
  }

  ajaxArticle() {
    const methods = [
      'breadcrumb',
      'title',
      'image_focus_hintergrund_mini',
      'image_focus_hintergrund_teaser',
      'image_focus_hintergrund_background'
    ].join();

    $.ajax({
      url: `/api/v3/articles/${this.props.articleId}.json?methods=${methods}`,
      method: 'GET',
      success: (data) => {
        if (data !== undefined && data !== null) {
          this.setState({ article: ArticlePresenter.getArticle(data) }, () => {
            loadLargeImage(this);
          });
        }
      },
      error: (xhr, status, err) => console.error(this.props.articleId, status, err.toString())
    });
  }

  ajaxTeaserArticles() {
    $.ajax({
      url: `/api/v3/articles/${this.props.articleId}/index.json`,
      method: 'GET',
      success: (data) => {
        if (data !== undefined && data !== null) {
          const teaserArticles = data.articles.reduce((accumulator, slideArticle) => {
            // skip parent article itself, if slideArticleId is the props articleId
            if (slideArticle[0] === this.props.articleId) {
              return accumulator;
            }
            // skip articles with checked `display_index_articles`
            if (slideArticle[1]) {
              return accumulator;
            }

            accumulator.push(<ListTeaser articleId={slideArticle[0]} compact />);

            return accumulator;
          }, []);

          this.setState({ teaserArticles });
        }
      },
      error: (xhr, status, err) => console.error(this.props.articleId, status, err.toString())
    });
  }

  render() {
    return (
      <div className="article-index background-fixed" style={this.state.article.imageBackground}>
        <section>
          <div className="container">
            <div className="row">
              <aside className="sidebar">&nbsp;</aside>

              <article className="content margin-bottom-xs">
                <div className="breadcrumb-headline">
                  <Breadcrumb breadcrumb={this.state.article.breadcrumb} />
                  <h1 className="no-margin-top no-margin-bottom">{this.state.article.title}</h1>
                </div>
                <div className="row">
                  <div className="col-1-of-2 main-content content-lg" />
                </div>
              </article>

              <aside className="spacebar">&nbsp;</aside>
            </div>
          </div>
        </section>
        {this.state.teaserArticles.map((teaserArticle, index) => (
          <section key={index}>{teaserArticle}</section>
        ))}
      </div>
    );
  }
}

TeaserArticles.propTypes = {
  articleId: React.PropTypes.number,
  articleType: React.PropTypes.string
};

export default TeaserArticles;



// WEBPACK FOOTER //
// ./components/articles/teaserArticles.js